import React, { useEffect } from "react";
import { TextField, InputAdornment, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import SelectLuvers from "./SelectLuvers";

const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      width: "",
    },
  }));
function ConfigureLuvers(props: any) {
  const measureUnit = 'Cm';
  const classes = useStyles();
  return (
    <div className="ConfigureLuvers">
      {" "}
      <h2>Oczka: </h2>
      <Grid container spacing={2} className="Grid-luvers">
        <Grid item xs={2}>
          <b>Szczyt:</b>
        </Grid>
        <Grid item xs={3}>
          {" "}
          <TextField
            label="Liczyć"
            id="standard-start-adornment"
            type="number"
            value={props.konfigured["top_luvers_count"]}
            name="top_luvers_count"
            onChange={(e) => props.onSelectChange(e)}
            className={clsx(classes.textField)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Dystans"
            id="standard-start-adornment"
            type="number"
            value={props.konfigured["top_luvers_distance"]}
            name="top_luvers_distance"
            onChange={(e) => props.onSelectChange(e)}
            className={clsx(classes.textField)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{measureUnit}</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectLuvers
            luverSelects={props.luverSelects}
            konfigured={props.konfigured}
            name="top_luvers"
            value={props.konfigured["top_luvers"]}
            onSelectChange={props.onSelectChange}
          ></SelectLuvers>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="Grid-luvers">
        <Grid item xs={2}>
          <b>Prawo:</b>
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Liczyć"
            id="standard-start-adornment"
            type="number"
            value={props.konfigured["right_luvers_count"]}
            name="right_luvers_count"
            onChange={(e) => props.onSelectChange(e)}
            className={clsx(classes.textField)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Dystans"
            id="standard-start-adornment"
            type="number"
            className={clsx(classes.textField)}
            value={props.konfigured["right_luvers_distance"]}
            name="right_luvers_distance"
            onChange={(e) => props.onSelectChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{measureUnit}</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectLuvers
            luverSelects={props.luverSelects}
            konfigured={props.konfigured}
            name="right_luvers"
            value={props.konfigured["right_luvers"]}
            onSelectChange={props.onSelectChange}
          ></SelectLuvers>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="Grid-luvers">
        <Grid item xs={2}>
          <b>Lewo:</b>
        </Grid>
        <Grid item xs={3}>
          {" "}
          <TextField
            label="Liczyć"
            id="standard-start-adornment"
            type="number"
            value={props.konfigured["left_luvers_count"]}
            name="left_luvers_count"
            onChange={(e) => props.onSelectChange(e)}
            className={clsx(classes.textField)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Dystans"
            id="standard-start-adornment"
            type="number"
            className={clsx(classes.textField)}
            value={props.konfigured["left_luvers_distance"]}
            name="left_luvers_distance"
            onChange={(e) => props.onSelectChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{measureUnit}</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectLuvers
            luverSelects={props.luverSelects}
            konfigured={props.konfigured}
            onSelectChange={props.onSelectChange}
            name="left_luvers"
            value={props.konfigured["left_luvers"]}
          ></SelectLuvers>
        </Grid>
      </Grid>
      <Grid container spacing={2} className="Grid-luvers">
        <Grid item xs={2}>
          <b>Spód:</b>
        </Grid>
        <Grid item xs={3}>
          {" "}
          <TextField
            label="Liczyć"
            id="standard-start-adornment"
            type="number"
            className={clsx(classes.textField)}
            value={props.konfigured["bottom_luvers_count"]}
            name="bottom_luvers_count"
            onChange={(e) => props.onSelectChange(e)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label="Dystans"
            id="standard-start-adornment"
            type="number"
            className={clsx(classes.textField)}
            value={props.konfigured["bottom_luvers_distance"]}
            name="bottom_luvers_distance"
            onChange={(e) => props.onSelectChange(e)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{measureUnit}</InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectLuvers
            luverSelects={props.luverSelects}
            konfigured={props.konfigured}
            value={props.konfigured["bottom_luvers"]}
            onSelectChange={props.onSelectChange}
            name="bottom_luvers"
          ></SelectLuvers>
        </Grid>
      </Grid>
    </div>
  );
}

export default ConfigureLuvers;
